var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 15.998,
    viewBox: "0 0 16.003 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    d: "M45,501l0-10H61v10Zm10-2h3v-2H55Zm-3,0h2v-2H52Zm-4,0h3v-2H48Zm7-4h3v-2H55Zm-3,0h2v-2H52Zm-4,0h3v-2H48Zm-3-6v-2h4v-2h2v2h4v-2h2v2h4v2Z",
    transform: "translate(-44.998 -484.999)",
    fill: "#aaa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a52f56cc.svg";
export { ForwardRef as ReactComponent };